import React, { useState, useEffect } from "react";
import { getCompany } from "../api/crud";
import { engApi } from "../api/engApi";
import { convertDateToString, matchOptions } from "../utils/function";
import { GiFactory } from "react-icons/gi";
import { Link } from "react-router-dom";
import { internType } from "../data/interntype-data";
import { BsPencilSquare } from "react-icons/bs";

const InternData = ({ st_id }) => {
  const [internDetail, setInternDetail] = useState([]);
  const [optionsCompany, setOptionsCompany] = useState([]);
  const getUsername = localStorage.getItem("username");
  const [onEdit, setOnEdit] = useState(false);

  const onEditClick = () => {
    setOnEdit(!onEdit);
  };

  const getInternData = async () => {
    const response = await engApi.get("/get-internship-request/");

    try {
      const match = await response.data?.filter((el) => el.st_id == st_id);

      const list = match.map((item) => {
        const companySelected = optionsCompany?.find(
          (el) => el.value == item?.cp_id
        );

        return {
          ...item,
          companyDetail: companySelected,
        };
      });

      if (list.length) {
        console.log({ list });
        setInternDetail(list);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCompanyList = async () => {
    getCompany()
      .then((res) => {
        const list = res.map((company) => {
          return {
            label: company.name,
            value: company.id,
            data: company,
          };
        });

        setOptionsCompany(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);
  useEffect(() => {
    getInternData();
  }, [optionsCompany]);

  console.log({ internDetail });

  const displayInternData = (
    <div className="">
      <div className="card mb-3">
        <div className="card-header">
          <h5 className="card-title mb-0">
            <div className="d-flex justify-content-between">
              <div>ข้อมูลฝึกงาน</div>
            </div>
          </h5>
        </div>

        <div className="card-body">
          <div
            id="carouselExampleIndicators"
            className="carousel carousel-dark slide pb-4"
            // data-bs-ride="carousel"
            data-bs-interval={false}
          >
            <div className="carousel-indicators">
              {internDetail.length &&
                internDetail.map((item, cIndex) => {
                  return (
                    <div
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to={cIndex}
                      className={cIndex + 1 == internDetail.length && "active"}
                      aria-current="true"
                      aria-label={`companyIndex-${cIndex}`}
                    />
                  );
                })}
            </div>

            <div className="carousel-inner">
              {internDetail.length
                ? internDetail.map((item, index) => {
                    return (
                      <div
                        className={`carousel-item ${index == 0 && "active"}`}
                      >
                        <form
                          action="./update-company-detail.php"
                          method="post"
                        >
                          <div className="text-end">
                            {onEdit &&
                              (item.status == "1" || item.status == "2") && (
                                <button
                                  className="btn btn-primary mx-2 btn-sm"
                                  type="submit"
                                >
                                  บันทึก
                                </button>
                              )}

                            {(item.status == "1" || item.status == "2") && (
                              <BsPencilSquare
                                size="1rem"
                                onClick={onEditClick}
                                role="button"
                              />
                            )}
                          </div>
                          <table className="table table-sm my-2">
                            <tbody>
                              <tr>
                                <th>สถานประกอบการ</th>
                                <td>
                                  <span className="badge bg-info">
                                    ID : {item?.cp_id}
                                  </span>{" "}
                                  {item?.companyDetail?.label}{" "}
                                </td>
                              </tr>
                              <tr>
                                <th>ที่อยู่สถานประกอบการ</th>
                                <td>
                                  {item?.companyDetail?.data.address} ต.
                                  {item?.companyDetail?.data.subdistrict} อ.
                                  {item?.companyDetail?.data.district} จ.
                                  {item?.companyDetail?.data.province}{" "}
                                  {item?.companyDetail?.data.zip}
                                </td>
                              </tr>
                              <tr>
                                <th>ชื่อผู้ประสานงาน</th>
                                <td>
                                  <input
                                    readOnly={
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2")
                                    }
                                    className={`form-control ps-0 ${
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2") &&
                                      "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="co_name"
                                    defaultValue={item?.co_name}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>ตำแหน่ง</th>
                                <td>
                                  <input
                                    readOnly={
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2")
                                    }
                                    className={`form-control ps-0 ${
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2") &&
                                      "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="co_pos"
                                    defaultValue={item?.co_pos}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Email ผู้ประสานงาน</th>
                                <td>
                                  <input
                                    readOnly={
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2")
                                    }
                                    className={`form-control ps-0 ${
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2") &&
                                      "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="co_email"
                                    defaultValue={item?.co_email}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>เบอร์โทร</th>
                                <td>
                                  <input
                                    readOnly={
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2")
                                    }
                                    className={`form-control ps-0 ${
                                      !onEdit &&
                                      (item.status !== "1" ||
                                        item.status !== "2") &&
                                      "field-editable"
                                    }`}
                                    style={{ color: "inherit" }}
                                    name="cp_tel"
                                    defaultValue={item?.cp_tel}
                                  />
                                </td>
                              </tr>
                              {item.comment && item.comment !== "-" && (
                                <tr>
                                  <th>หมายเหตุ</th>
                                  <td style={{ color: "#b31717" }}>
                                    <input
                                      readOnly={
                                        !onEdit ||
                                        item.status !== "1" ||
                                        item.status !== "2"
                                      }
                                      className={`form-control ps-0 ${
                                        (!onEdit ||
                                          item.status !== "1" ||
                                          item.status !== "2") &&
                                        "field-editable"
                                      }`}
                                      style={{ color: "inherit" }}
                                      name="comment"
                                      defaultValue={item?.comment}
                                    />
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <th>ประเภทการฝึกงาน</th>
                                <td>
                                  {matchOptions(
                                    internType,
                                    item?.type_internship
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>ช่วงวันที่</th>
                                <td>
                                  {!onEdit ? (
                                    <>
                                      {convertDateToString(item?.start_date)} -{" "}
                                      {convertDateToString(item?.end_date)}
                                    </>
                                  ) : (
                                    <div className="d-flex">
                                      <input
                                        readOnly={
                                          !onEdit &&
                                          (item.status !== "1" ||
                                            item.status !== "2")
                                        }
                                        className={`form-control w-50 ps-0 ${
                                          !onEdit &&
                                          (item.status !== "1" ||
                                            item.status !== "2") &&
                                          "field-editable"
                                        }`}
                                        style={{ color: "inherit" }}
                                        name="start_date"
                                        defaultValue={item?.start_date}
                                      />
                                      <div>-</div>
                                      <input
                                        readOnly={
                                          !onEdit &&
                                          (item.status !== "1" ||
                                            item.status !== "2")
                                        }
                                        className={`form-control w-50 ps-0 ${
                                          !onEdit &&
                                          (item.status !== "1" ||
                                            item.status !== "2") &&
                                          "field-editable"
                                        }`}
                                        style={{ color: "inherit" }}
                                        name="end_date"
                                        defaultValue={item?.end_date}
                                      />
                                    </div>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>สถานะเอกสาร</th>
                                <td>
                                  {item?.status == 0 && (
                                    <span className="badge bg-danger">
                                      ยกเลิก
                                    </span>
                                  )}
                                  {item?.status == 1 && (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  )}
                                  {item?.status == 2 && (
                                    <span className="badge bg-success">
                                      Approved
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <input
                            name="req_id"
                            className="d-none"
                            value={item?.req_id}
                          />
                        </form>
                      </div>
                    );
                  })
                : ""}
            </div>
            {/* <div
              className="carousel-control-prev "
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon "
                aria-hidden="true"
              />
              <span className="visually-hidden">Previous</span>
            </div>
            <div
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {internDetail.length ? (
        displayInternData
      ) : (
        <div className="card h-100">
          <div className="card-body d-flex justify-content-center align-items-center">
            <div>
              {getUsername == st_id ? (
                <Link to="/request-form" className="btn btn-light">
                  ยื่นความประสงค์ขอฝึกงาน
                </Link>
              ) : (
                <div>ยังไม่ได้ยื่นความประสงค์ขอฝึกงาน</div>
              )}
              <div className="text-center">
                <GiFactory fontSize="100px" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InternData;
